(function ($) {
	$.formField = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			FormField = (function ($c, o) {
				var defaults = {
					activeClass: 'active'
				}; 

				var _o = {},
					$f = null // Input Field
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$f = $('.ninja-forms-field', $c);
				},

				_OnFocus = function(e) {
					_SetActive();
				},

				_OnOver = function(e) {
					_SetActive();
				},

				_OnOut = function(e) {
					_SetInactive();
				},

				_OnBlur = function(e) {
					_SetInactive();
				},

					_SetActive = function() {
						if (!$c.hasClass(_o.activeClass)) {
							$c.addClass(_o.activeClass);
						}
					},

					_SetInactive = function() {
						var v = $f.val();

						if (v !== '') {
							if (!$c.hasClass(_o.activeClass)) {
								$c.addClass(_o.activeClass);
							}
						} else {
							if ($c.hasClass(_o.activeClass)) {
								$c.removeClass(_o.activeClass);
							}
						}
					},

				_BindEvents = function () {
					$f.focus(_OnFocus);
					$f.blur(_OnBlur);
					$f.hover(_OnOver, _OnOut);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.formField = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('formField')) {
				var plugin = new $.formField(this, options);
				$(this).data('formField', plugin);
			}
		});
	};
})(jQuery);
